import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import initialState from './initialState'
import { HamburgerNavItem, HamburgerNavSettings } from './types'

const slice = createSlice({
  name: 'appNavigationHamburgerNav',
  initialState,
  reducers: {
    updateSettings: (
      state,
      action: PayloadAction<Partial<HamburgerNavSettings>>
    ) => {
      state.settings = {
        ...state.settings,
        ...action.payload,
      }
      state.hasChanges = true
    },
    addNavItem: (state, action: PayloadAction<HamburgerNavItem>) => {
      if (!state.settings.items) {
        state.settings.items = []
      }
      state.settings.items.push(action.payload)
      state.hasChanges = true
    },
    updateNavItem: (
      state,
      action: PayloadAction<{ id: string; data: Partial<HamburgerNavItem> }>
    ) => {
      if (state.settings.items) {
        const index = state.settings.items.findIndex(
          item => item.id === action.payload.id
        )
        if (index !== -1) {
          state.settings.items[index] = {
            ...state.settings.items[index],
            ...action.payload.data,
          }
          state.hasChanges = true
        }
      }
    },
    removeNavItem: (state, action: PayloadAction<string>) => {
      if (state.settings.items) {
        state.settings.items = state.settings.items.filter(
          item => item.id !== action.payload
        )
        state.hasChanges = true
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    resetChanges: state => {
      state.hasChanges = false
    },
    reset: (state, action: PayloadAction<HamburgerNavSettings>) => {
      state.settings = action.payload
      state.hasChanges = false
      state.isLoading = false
    },
  },
})

export const reducer = slice.reducer
export const {
  updateSettings,
  addNavItem,
  updateNavItem,
  removeNavItem,
  setLoading,
  resetChanges,
  reset,
} = slice.actions
